export interface ManipulatedComponent {
  name: string;
  concentration: string;
  freeText?: string;
}

export interface ManipulatedPayloadData {
  components: ManipulatedComponent[];
  treatmentDays: string;
  totalDoses: string;
  route: string;
  pharmaceuticalForm: string;
  instructions: string;
  freeText: string;
}

function normalizeText(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

/** Parses the `manipulated_payload` JSONB column (as returned by Supabase) into a typed shape for rendering. */
export function parseManipulatedPayload(payload: unknown): ManipulatedPayloadData | null {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) return null;
  const raw = payload as Record<string, unknown>;
  const rawComponents = Array.isArray(raw.components) ? raw.components : [];
  const components = rawComponents
    .map((component) => {
      const normalized =
        component && typeof component === "object" ? (component as Record<string, unknown>) : {};
      return {
        name: normalizeText(normalized.name),
        concentration: normalizeText(normalized.concentration),
        freeText: normalizeText(normalized.free_text) || undefined,
      };
    })
    .filter((component) => component.name || component.concentration || component.freeText);

  return {
    components,
    treatmentDays: normalizeText(raw.treatment_days != null ? String(raw.treatment_days) : ""),
    totalDoses: normalizeText(raw.total_doses != null ? String(raw.total_doses) : ""),
    route: normalizeText(raw.route),
    pharmaceuticalForm: normalizeText(raw.pharmaceutical_form),
    instructions: normalizeText(raw.instructions),
    freeText: typeof raw.free_text === "string" ? raw.free_text.trim() : "",
  };
}
